// firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

// const firebaseConfig = {
//   apiKey: "AIzaSyBeZSlYeZwVAv5VUC8-G7VP4rA67150JP4",
//   authDomain: "wannaeatstage.firebaseapp.com",
//   projectId: "wannaeatstage",
//   storageBucket: "wannaeatstage.firebasestorage.app",
//   messagingSenderId: "791321908260",
//   appId: "1:791321908260:web:cd3383251d42d2462af4b1",
//   measurementId: "G-JPKTRH2G6F"
// };
const firebaseConfig = {
  apiKey: "AIzaSyABEpo7uZ7J0zb5GzY4TxluvE_jSAKUsFs",
  authDomain: "wannaeat-355412.firebaseapp.com",
  projectId: "wannaeat-355412",
  storageBucket: "wannaeat-355412.firebasestorage.app",
  messagingSenderId: "230488693724",
  appId: "1:230488693724:web:5cb1df6ff61168eaef8d19",
  measurementId: "G-PXBLRXTEDE"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);